module.exports = require('./helpers/bundle-url').getBundleURL('4xJtr') + "logo-dark.eefe0b7f.svg";